import { api } from "..";

export async function saveMarketMatch({
  matchId,
  providerId,
  state,
}: {
  matchId: string;
  providerId: string;
  state: Record<string, any>;
}) {
  const res = await api.client.post("/matches/markets", {
    id: matchId.toString(),
    providerId: providerId.toString(),
    state,
  });
  return res.data;
}
